import * as yup from 'yup';
const isAdult = (date) => {
  const today = new Date();
  const birthDate = new Date(date);
  const age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    return age - 1;
  }
  return age;
};


export const signatoryValidationSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('El nombre es obligatorio')
    .max(100, 'El nombre no debe exceder los 100 caracteres'),
  lastName: yup
    .string()
    .required('El apellido es obligatorio')
    .max(100, 'El apellido no debe exceder los 100 caracteres'),
  phone: yup
    .string()
    .required('El teléfono es requerido')
    .matches(/^\d+$/, 'El teléfono solo puede contener números'),
  email: yup
    .string()
    .email('No es un correo válido')
    .required('El correo electrónico es obligatorio'),
  documentClient: yup.string().required('El documento es requerido'),
  identificationTypeId: yup.mixed().required('El tipo de documento es obligatorio'),
  societyId: yup.mixed().required('La sociedad es obligatoria'),
  birthDate: yup
    .date()
    .required('La fecha de nacimiento es obligatoria')
    .test(
      'is-adult',
      'Debe ser mayor de 18 años',
      (value) => value && isAdult(value) >= 18
    ),
  positionId: yup.mixed().required('La posición es obligatoria'),
});
